import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import CapabilitiesSection from '../components/sections/CapabilitiesSection';
import AboutSection from '../components/sections/AboutSection';
import ProductsSection from '../components/sections/ProductsSection';
import MachineSection from '../components/sections/MachineSection';
import IndustrySection from '../components/sections/IndustrySection';
import CertificationSection from '../components/sections/CertificationSection';
import ClientsSection from '../components/sections/ClientsSection';
import CTASection from '../components/sections/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <HeroSection />
        <CapabilitiesSection />
        <AboutSection />
        <ProductsSection />
        <MachineSection />
        <IndustrySection />
        <CertificationSection />
        <ClientsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
